export default {
  title: 'Volg je bestelling',
  text: 'Bedankt voor je bestelling! Onze <0>{{carrier}}</0>-samenwerking stelt ons in staat bezorgingen direct via onze site te regelen, waardoor we gemiddeld {{savings}} besparen op bezorgprovisies. Je bestelling wordt bezorgd door <1>{{carrier}}</1>, voor uitstekende service 😊',
  labels: {
    delivered_by: 'Bezorgd door',
  },
  buttons: {
    track_order: 'Volg je bestelling live →',
    track_order_once_confirmed: 'Volg je bestelling live zodra bevestigd',
  },
};
